
    /*!
    * Copyright (c) Microsoft Corporation.
    * All rights reserved. See LICENSE in the project root for license information.
    * THIS FILE IS AN AUTOGENERATED TYPESCRIPT PROXY EXTENSION.
    * TO USE THIS FILE, IT MUST BE ADDED TO A D365COMMERCE APPLICATION
    */
    // tslint:disable
    import { AsyncResult, callActionOrExecute, DataServiceQuery, IContext, IDataServiceRequest } from '@msdyn365-commerce/retail-proxy';
    // @ts-ignore
    import * as EntityClasses from '@msdyn365-commerce/retail-proxy/dist/Entities/CommerceModels.g';
    import * as DataServiceEntities from './DataServiceEntities.g';

    
       
        // @ts-ignore
        function mfrCodeQuery(product?: number): DataServiceQuery {
        const key = (product) ? { Product: product } :null;
        return new DataServiceQuery("MfrCode", "MfrCodeClass", DataServiceEntities.MfrCodeClassExtensionClass, key);
        }

        
    export function createGetMfrCodeInput(productId: number): IDataServiceRequest {
    const query = mfrCodeQuery();
    return query.createDataServiceRequestForOperation('GetMfrCode', false, DataServiceEntities.MfrCodeClassExtensionClass, 'false', {bypassCache: 'none', returnEntity: 'DataServiceEntities.IMfrCodeClass'}, {productId: productId });
    }

    
    export function getMfrCodeAsync(context: IContext, productId: number): AsyncResult<DataServiceEntities.IMfrCodeClass> {
    const request = createGetMfrCodeInput(productId);
    return callActionOrExecute<DataServiceEntities.IMfrCodeClass>(request, context.callerContext);
    }
  